export type NavbarChildNavigationType = {
  title: string
  url: string
  featureFlag?: string
}

export type NavbarNavigationType = {
  title: string
  url?: string
  child?: NavbarChildNavigationType[]
}

const navbarNavigations: NavbarNavigationType[] = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "info",
    child: [
      {
        title: "brands",
        url: "/info/brands",
      },
      {
        title: "Delivery",
        url: "/info/delivery",
      },
      {
        title: "USPs",
        url: "/info/usps",
      },
    ],
  },
  {
    title: "colorChart",
    child: [
      {
        title: "coatings",
        url: "/colors/coatings",
      },
    ],
  },
  {
    title: "fabrics",
    child: [
      {
        title: "prices",
        url: "/fabrics/prices",
      },
      {
        title: "fabricsOverview",
        url: "/fabrics/overview",
      },
      {
        title: "outdoorStock",
        url: "/fabrics/outdoor-stock",
      },
      { title: "info", url: "/fabrics/info" },
    ],
  },
]
export default navbarNavigations
